// J3Cargo retail rates by Nigerian state (above 5kg). £/kg + minimum charge.
export const STATE_RATES = {
  Lagos:            { perKg: 6.50, min: 65 },
  Oyo:              { perKg: 6.80, min: 80 },
  Ogun:             { perKg: 7.00, min: 80 },
  Ondo:             { perKg: 7.00, min: 80 },
  Osun:             { perKg: 7.00, min: 80 },
  Ekiti:            { perKg: 7.00, min: 80 },
  Kwara:            { perKg: 7.00, min: 85 },
  Abia:             { perKg: 7.50, min: 85 },
  "Abuja (FCT)":    { perKg: 7.50, min: 85 },
  "Akwa Ibom":      { perKg: 7.50, min: 85 },
  Anambra:          { perKg: 7.50, min: 85 },
  Bayelsa:          { perKg: 7.50, min: 85 },
  Benue:            { perKg: 7.50, min: 85 },
  "Cross River":    { perKg: 7.50, min: 85 },
  Delta:            { perKg: 7.50, min: 85 },
  Ebonyi:           { perKg: 7.50, min: 85 },
  Edo:              { perKg: 7.50, min: 85 },
  Enugu:            { perKg: 7.50, min: 85 },
  Imo:              { perKg: 7.50, min: 85 },
  Rivers:           { perKg: 7.50, min: 85 },
  Yobe:             { perKg: 7.50, min: 85 },
  Bauchi:           { perKg: 8.00, min: 95 },
  Gombe:            { perKg: 8.00, min: 95 },
  Jigawa:           { perKg: 8.00, min: 95 },
  Kaduna:           { perKg: 8.00, min: 95 },
  Kano:             { perKg: 8.00, min: 95 },
  Katsina:          { perKg: 8.00, min: 95 },
  Kebbi:            { perKg: 8.00, min: 95 },
  Kogi:             { perKg: 8.00, min: 95 },
  Plateau:          { perKg: 8.00, min: 95 },
  Sokoto:           { perKg: 8.00, min: 95 },
  Taraba:           { perKg: 8.00, min: 95 },
  Zamfara:          { perKg: 8.50, min: 95 },
  Adamawa:          { perKg: 8.50, min: 95 },
  Borno:            { perKg: 8.50, min: 95 },
  Nasarawa:         { perKg: 8.50, min: 100 },
  Niger:            { perKg: 8.50, min: 100 },
};

export const NIGERIAN_STATES = Object.keys(STATE_RATES);

// Fixed-price items (flat rate to Lagos regardless of weight).
export const FIXED_PRICE_ITEMS = {
  "Laptop / Tablet / iPad": 50,
  "Desktop Computer": 150,
  "19\" TV": 120,
  "26\" TV": 150,
  "32\" TV": 170,
  "37\" TV": 190,
  "40\" TV": 290,
  "47\" TV": 410,
  "50\" TV": 500,
  "55\" TV": 570,
  "60-62\" TV": 620,
  "75\" TV": 720,
  "80\" TV": 750,
  "90\" TV": 850,
  "American Fridge": 800,
  "Washing Machine": 550,
  "Cooker": 250,
};

export const FIXED_PRICE_KEYS = Object.keys(FIXED_PRICE_ITEMS);

/**
 * Calculate MPS service fee based on product value.
 */
export function calculateServiceFee(productValue) {
  if (productValue <= 0) return 0;
  if (productValue <= 100) return 20;
  if (productValue <= 300) return +(productValue * 0.15).toFixed(2);
  if (productValue <= 600) return +(productValue * 0.12).toFixed(2);
  return 75; // £600+ minimum (negotiated)
}

/**
 * Calculate freight for a standard (non-fixed-price) item.
 */
export function calculateFreight(weightKg, state) {
  if (!weightKg || weightKg <= 0) return 0;
  if (weightKg < 2) return 35;
  if (weightKg <= 5) return 50;
  const rate = STATE_RATES[state];
  if (!rate) return 0;
  const computed = +(weightKg * rate.perKg).toFixed(2);
  return Math.max(computed, rate.min);
}

/**
 * Build a quote.
 */
export function calculateQuote({
  productValue = 0,
  weightKg = 0,
  state = "Lagos",
  isComplexSourcing = false,
  fixedPriceItem = null,
}) {
  const breakdown = [];

  let serviceFee = 0;
  let freightCost = 0;
  const sourcingFee = isComplexSourcing ? 30 : 0;

  if (fixedPriceItem && FIXED_PRICE_ITEMS[fixedPriceItem] != null) {
    serviceFee = calculateServiceFee(productValue);
    freightCost = FIXED_PRICE_ITEMS[fixedPriceItem];
    breakdown.push({ label: `Service Fee (product £${productValue.toFixed(2)})`, amount: serviceFee });
    breakdown.push({ label: `Fixed-rate Freight — ${fixedPriceItem} to Lagos`, amount: freightCost });
  } else {
    serviceFee = calculateServiceFee(productValue);
    freightCost = calculateFreight(weightKg, state);
    breakdown.push({ label: `Service Fee (product £${productValue.toFixed(2)})`, amount: serviceFee });
    breakdown.push({ label: `Freight to ${state}${weightKg ? ` (${weightKg}kg)` : ""}`, amount: freightCost });
  }

  if (sourcingFee > 0) {
    breakdown.push({ label: "Complex Sourcing Fee", amount: sourcingFee });
  }

  const total = +(serviceFee + freightCost + sourcingFee).toFixed(2);

  return { serviceFee, freightCost, sourcingFee, total, breakdown };
}

export const formatGBP = (n) =>
  `£${(Number(n) || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
